import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import users from '../assets/icons/users.png';
import editBill from '../assets/icons/editBill.png';
import collectionCenter from '../assets/icons/collectionCenter.png';
import collectionreport from '../assets/icons/collectionreport.png';
import URL from '../constants/ServerUrl';
import apiConnector from '../utils/axios'
import Navbar from './Navbar';
import { convertDateToAD, convertDateToBS } from '../utils/convertDate';

const screens = [
  { name: 'Collection Center', component: 'CollectionCenter', image: collectionCenter },
  { name: 'Collection Report', component: 'CollectionReport', image: collectionreport },
  { name: 'Users', component: 'Users', image: users },
  { name: 'Edit Bill', component: 'BillDetails', image: editBill },
];

const HomeScreen = () => {
  const navigate = useNavigate();

  const handleNavigation = (component) => {
    navigate(`/${component}`);
  };

  const currentDate = new Date();
  const dayOfWeek = currentDate.getDay();
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();

  const startOfDay = new Date()
startOfDay.setHours(0, 0, 0, 0)

const endOfDay = new Date(startOfDay)
endOfDay.setHours(23, 59, 59, 999)

  const [totalMilk, setTotalMilk] = useState(0);
  const [avgFat, setAvgFat] = useState(0);
  const [avgSNF, setAvgSNF] = useState(0);
  const token = localStorage.getItem("dairy-token")

  const fetchTotalMilk = async () => {
    try {
      const res = await axios.get(
        `${URL}admin/collection/totalmilk?start=${startOfDay}&end=${endOfDay}`,{

          Authorization: `Bearer ${token}`,

        }
      )
      setTotalMilk((res.data.length && res.data[0].totalMilk.toFixed(2)) || 0)
      console.log(res.data);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAvgFat = async () => {
    try {
      const res = await axios.get(
        `${URL}admin/collection/avgfat?start=${startOfDay}&end=${endOfDay}`,{
          Authorization: `Bearer ${token}`,
        }
      )
      setAvgFat(res.data || 0)
      console.log(res.data);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAvgSNF = async () => {
    try {
      const res = await axios.get(
        `${URL}admin/collection/avgsnf?start=${startOfDay}&end=${endOfDay}`,{
          Authorization: `Bearer ${token}`,
        }
      )
      setAvgSNF(res.data || 0)
      console.log(res.data);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    try {
      fetchTotalMilk()
      fetchAvgFat()
      fetchAvgSNF()
    } catch (error) {
      console.log(error)
    }
  }, [])


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-green-50 p-8">
    <div className="flex flex-col items-center justify-center mb-8">
      <h2 className="text-3xl font-bold mb-2">{daysOfWeek[dayOfWeek]}</h2>
      <p className="text-lg">{String(convertDateToBS(currentDate))}</p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-6 bg-white rounded-md shadow-md">
          <p className="font-semibold text-lg">TOTAL MILK</p>
          <p className="text-xl">{totalMilk} Lt</p>
        </div>
        <div className="p-6 bg-white rounded-md shadow-md">
          <p className="font-semibold text-lg">AVERAGE FAT</p>
          <p className="text-xl">{avgFat}</p>
        </div>
        <div className="p-6 bg-white rounded-md shadow-md">
          <p className="font-semibold text-lg">AVERAGE SNF</p>
          <p className="text-xl">{avgSNF}</p>
        </div>
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {screens.map(({ name, component, image }) => (
        <div
          key={component}
          className="p-6 bg-white rounded-md shadow-md flex flex-col items-center justify-center cursor-pointer"
          onClick={() => handleNavigation(component)}
        >
          <img src={image} alt={name} className="w-20 h-20 mb-3" />
          <p className="text-lg font-medium text-center">{name}</p>
        </div>
      ))}
    </div>
  </div>
  );
};

export default HomeScreen;
